module.exports = "<p>\n  deptenquirydetails-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/deptenquirydetails/deptenquirydetails-form/deptenquirydetails-form.component.html
// module id = ./src/app/hrms/serviceregister/deptenquirydetails/deptenquirydetails-form/deptenquirydetails-form.component.html
// module chunks = main